import { Button, Container, Heading } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { StaticPagesRoutes } from '@/routes/_hooks/routes.enum'
import { Link } from '@/routing'

import { Denied } from '../../atoms/Illustrations/Denied'

export const Unauthorized403 = () => {
  const { t } = useTranslation()
  return (
    <>
      <title>
        {t('errors.unauthorized.title')} {'< Communo'}
      </title>

      <Container maxW="3xl" my={10} textAlign="center">
        <Heading as="h1" mb={0}>
          {t('errors.unauthorized.title')}
        </Heading>
        <Denied height="300px" />
        <Link to={StaticPagesRoutes.Home}>
          <Button variant="outline">{t('global:back')}</Button>
        </Link>
      </Container>
    </>
  )
}
